'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function DJFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-jixeexw13", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-8q5lb4vos", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-vr5gvzup9" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-tv9mf9vqq", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-snd955ul7" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-vr5gvzup9", d: "M0 0h32v24H0z" }), /* @__PURE__ */ React.createElement("path", { id: "mantine-snd955ul7", d: "M0 0v24l18-12z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-jixeexw13)" }, /* @__PURE__ */ React.createElement("use", { fill: "#73be4a", xlinkHref: "#mantine-vr5gvzup9" }), /* @__PURE__ */ React.createElement("path", { fill: "#69f", d: "M0-2h32v14H0z", mask: "url(#mantine-8q5lb4vos)" }), /* @__PURE__ */ React.createElement("use", { fill: "#fff", xlinkHref: "#mantine-snd955ul7" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#e31d1c",
        d: "M7.002 14.07l-1.87 1.13.426-2.204L4 11.347l2.11-.09.892-2.057.892 2.058H10l-1.554 1.738.468 2.204z",
        mask: "url(#mantine-tv9mf9vqq)"
      }
    )))
  );
}

export { DJFlag };
//# sourceMappingURL=DJ.mjs.map
